// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-menu {
  position: relative;
  cursor: pointer;
}
@media (max-width: 768px) {
  .notification-menu {
    position: static;
  }
}
.notification-menu-icon {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 1rem 0.5rem;
  font-size: 16px;
  position: relative;
}
.notification-menu-icon-count {
  padding: 3px;
  height: 3px;
  position: absolute;
  background: var(--purple6);
  border: 1px solid var(--white);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  font-size: 10px;
  font-weight: 600;
  top: 18px;
  left: 18px;
  z-index: 1;
}
.notification-menu-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  min-width: 400px;
  max-width: 500px;
  width: 100%;
  background: var(--white);
  border-radius: 0.5rem;
  box-shadow: 0 4px 24px -4px rgba(18, 20, 23, 0.08);
  right: 0;
  display: none;
}
@media (max-width: 768px) {
  .notification-menu-dropdown {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    border-radius: 0 0 0.5rem 0.5rem;
    z-index: 999;
    top: -1px;
    box-shadow: none;
    height: calc(100vh - 56px - 2rem);
  }
}
.notification-menu-dropdown-icon {
  margin-top: 0;
  margin-right: 0.75rem;
  width: 2.5rem;
  height: 2.5rem;
  min-width: 2.5rem;
  background: var(--purple1);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notification-menu-dropdown-icon > svg {
  transform: scale(1.125);
}
.notification-menu-dropdown-icon > svg * {
  stroke: var(--purple6);
}
.notification-menu-dropdown.open {
  display: flex;
  flex-direction: column;
}
.notification-menu-dropdown-footer {
  border-top: 1px solid var(--black1);
  margin: 0 1rem 0 1rem;
  padding: 1rem 0;
  font-size: 14px;
  color: var(--black6);
  cursor: pointer;
  display: flex;
  justify-content: center;
  background: var(--white);
}
.notification-menu-dropdown-footer span {
  display: flex;
}
.notification-menu-dropdown-header {
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid var(--black1);
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  justify-content: space-between;
  color: var(--black3);
  cursor: default;
}
@media (max-width: 768px) {
  .notification-menu-dropdown-header {
    box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);
  }
}
@media (min-width: 768px) {
  .notification-menu-dropdown-header-icon {
    display: none;
  }
}
.notification-menu-dropdown-header-more {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.notification-menu-dropdown-header-more-mobile {
  display: none;
  border-bottom: 1px solid var(--black1);
  padding: 1rem;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .notification-menu-dropdown-header-more-mobile {
    display: flex;
  }
}
.notification-menu-dropdown-header-title {
  display: flex;
  font-size: 15px;
  font-weight: 600;
  color: var(--black9);
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .notification-menu-dropdown-header-title {
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}
.notification-menu-dropdown-header-read {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: var(--purple6);
  cursor: pointer;
}
.notification-menu-dropdown-header-count {
  background: var(--purple6);
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
  border-radius: 5rem;
  padding: 0 0.25rem;
  display: flex;
  align-items: center;
  min-width: 1.5rem;
  justify-content: center;
}
.notification-menu-dropdown-header-count > div {
  height: 1rem;
  width: 1rem;
}
.notification-menu-dropdown-nothing {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: var(--black9);
  padding: 1.25rem;
  cursor: default;
}
.notification-menu-dropdown-body {
  max-height: 320px;
  overflow: auto;
}
@media (max-width: 768px) {
  .notification-menu-dropdown-body {
    max-height: 100%;
  }
}
.notification-menu-dropdown-body a {
  display: flex;
  align-items: flex-start;
  padding: 0.75rem 1rem;
}
.notification-menu-dropdown-body a:hover {
  text-decoration: none;
  background: var(--black0);
  color: var(--black9) !important;
}
.notification-menu-dropdown-body a:hover span {
  color: var(--black9) !important;
}
.notification-menu-dropdown-body a b {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  display: flex;
  margin-bottom: 4px;
}
.notification-menu-dropdown-body a span {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black9);
  display: flex;
  margin-bottom: 4px;
}
.notification-menu-dropdown-body a i {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: var(--black3);
}`, "",{"version":3,"sources":["webpack://./client/components/header/components/notification.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,eAAA;AACD;AACC;EAJD;IAKE,gBAAA;EAEA;AACF;AAAC;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;AAEF;AAAE;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAEH;AAEC;EACC,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,qBAAA;EACA,kDAAA;EACA,QAAA;EACA,aAAA;AAAF;AAEE;EAZD;IAaE,WAAA;IACA,eAAA;IACA,eAAA;IACA,gCAAA;IACA,YAAA;IACA,SAAA;IACA,gBAAA;IACA,iCAAA;EACD;AACF;AACE;EACC,aAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACH;AACG;EACC,uBAAA;AACJ;AAAI;EACC,sBAAA;AAEL;AAIE;EACC,aAAA;EACA,sBAAA;AAFH;AAKE;EACC,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,wBAAA;AAHH;AAKG;EACC,aAAA;AAHJ;AAOE;EACC,aAAA;EACA,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;AALH;AAOG;EAdD;IAeE,gDAAA;EAJF;AACF;AAOI;EADD;IAEE,aAAA;EAJH;AACF;AAOG;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AALJ;AAOI;EACC,aAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AALL;AAOK;EAPD;IAQE,aAAA;EAJJ;AACF;AAQG;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;AANJ;AAQI;EAPD;IAQE,uBAAA;IACA,mBAAA;IACA,WAAA;EALH;AACF;AAQG;EACC,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;AANJ;AAUG;EACC,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AARJ;AAUI;EACC,YAAA;EACA,WAAA;AARL;AAaE;EACC,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AAXH;AAcE;EACC,iBAAA;EACA,cAAA;AAZH;AAcG;EAJD;IAKE,gBAAA;EAXF;AACF;AAaG;EACC,aAAA;EACA,uBAAA;EACA,qBAAA;AAXJ;AAaI;EACC,qBAAA;EACA,yBAAA;EACA,+BAAA;AAXL;AAaK;EACC,+BAAA;AAXN;AAeI;EACC,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;AAbL;AAgBI;EACC,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;AAdL;AAiBI;EACC,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAfL","sourcesContent":[".notification-menu {\n\tposition: relative;\n\tcursor: pointer;\n\n\t@media (max-width: 768px) {\n\t\tposition: static;\n\t}\n\n\t&-icon {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 1rem .5rem;\n\t\tfont-size: 16px;\n\t\tposition: relative;\n\n\t\t&-count {\n\t\t\tpadding: 3px;\n\t\t\theight: 3px;\n\t\t\tposition: absolute;\n\t\t\tbackground: var(--purple6);\n\t\t\tborder: 1px solid var(--white);\n\t\t\tborder-radius: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tmin-width: auto;\n\t\t\tfont-size: 10px;\n\t\t\tfont-weight: 600;\n\t\t\ttop: 18px;\n\t\t\tleft: 18px;\n\t\t\tz-index: 1;\n\t\t}\n\t}\n\n\t&-dropdown {\n\t\tposition: absolute;\n\t\ttop: calc(100% + .5rem);\n\t\tmin-width: 400px;\n\t\tmax-width: 500px;\n\t\twidth: 100%;\n\t\tbackground: var(--white);\n\t\tborder-radius: .5rem;\n\t\tbox-shadow: 0 4px 24px -4px rgba(18, 20, 23, 0.08);\n\t\tright: 0;\n\t\tdisplay: none;\n\n\t\t@media (max-width: 768px) {\n\t\t\twidth: 100%;\n\t\t\tmin-width: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder-radius: 0 0 .5rem .5rem;\n\t\t\tz-index: 999;\n\t\t\ttop: -1px;\n\t\t\tbox-shadow: none;\n\t\t\theight: calc(100vh - 56px - 2rem);\n\t\t}\n\n\t\t&-icon {\n\t\t\tmargin-top: 0;\n\t\t\tmargin-right: .75rem;\n\t\t\twidth: 2.5rem;\n\t\t\theight: 2.5rem;\n\t\t\tmin-width: 2.5rem;\n\t\t\tbackground: var(--purple1);\n\t\t\tborder-radius: 0.5rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\t& > svg {\n\t\t\t\ttransform: scale(1.125);\n\t\t\t\t& * {\n\t\t\t\t\tstroke: var(--purple6);\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\t\t&.open {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t&-footer {\n\t\t\tborder-top: 1px solid var(--black1);\n\t\t\tmargin: 0 1rem 0 1rem;\n\t\t\tpadding: 1rem 0;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: var(--black6);\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\tbackground: var(--white);\n\n\t\t\tspan {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t}\n\n\t\t&-header {\n\t\t\tdisplay: flex;\n\t\t\tpadding: 1rem;\n\t\t\tborder-bottom: 1px solid var(--black1);\n\t\t\talign-items: center;\n\t\t\tfont-family: 'Inter';\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 15px;\n\t\t\tline-height: 18px;\n\t\t\tjustify-content: space-between;\n\t\t\tcolor: var(--black3);\n\t\t\tcursor: default;\n\n\t\t\t@media (max-width: 768px) {\n\t\t\t\tbox-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);\n\t\t\t}\n\n\t\t\t&-icon {\n\t\t\t\t@media (min-width: 768px) {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&-more {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 1rem;\n\n\t\t\t\t&-mobile {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t\tborder-bottom: 1px solid var(--black1);\n\t\t\t\t\tpadding: 1rem;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: space-between;\n\n\t\t\t\t\t@media (max-width: 768px) {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&-title {\n\t\t\t\tdisplay: flex;\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--black9);\n\t\t\t\tgap: .5rem;\n\n\t\t\t\t@media (max-width: 768px) {\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&-read {\n\t\t\t\tfont-family: 'Inter';\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tline-height: 16px;\n\t\t\t\tcolor: var(--purple6);\n\t\t\t\tcursor: pointer;\n\n\t\t\t}\n\n\t\t\t&-count {\n\t\t\t\tbackground: var(--purple6);\n\t\t\t\tfont-family: \"Inter\";\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tline-height: 16px;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: #FFFFFF;\n\t\t\t\tborder-radius: 5rem;\n\t\t\t\tpadding: 0 0.25rem;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tmin-width: 1.5rem;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\t& > div {\n\t\t\t\t\theight: 1rem;\n\t\t\t\t\twidth: 1rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&-nothing {\n\t\t\tfont-family: \"Inter\";\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 13px;\n\t\t\tline-height: 16px;\n\t\t\ttext-align: center;\n\t\t\tcolor: var(--black9);\n\t\t\tpadding: 1.25rem;\n\t\t\tcursor: default;\n\t\t}\n\n\t\t&-body {\n\t\t\tmax-height: 320px;\n\t\t\toverflow: auto;\n\n\t\t\t@media (max-width: 768px) {\n\t\t\t\tmax-height: 100%;\n\t\t\t}\n\n\t\t\ta {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tpadding: .75rem 1rem;\n\n\t\t\t\t&:hover {\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tbackground: var(--black0);\n\t\t\t\t\tcolor: var(--black9) !important;\n\n\t\t\t\t\tspan {\n\t\t\t\t\t\tcolor: var(--black9) !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tb {\n\t\t\t\t\tfont-family: 'Inter';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 17px;\n\t\t\t\t\tcolor: var(--black9);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tmargin-bottom: 4px;\n\t\t\t\t}\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-family: 'Inter';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\tline-height: 16px;\n\t\t\t\t\tcolor: var(--black9);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tmargin-bottom: 4px;\n\t\t\t\t}\n\n\t\t\t\ti {\n\t\t\t\t\tfont-family: 'Inter';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tline-height: 15px;\n\t\t\t\t\tcolor: var(--black3);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
